/**
 * Склонение числительных в русском языке для маркетинговых сводок Fitenko OS.
 */

export function pluralZapisi(n) {
  const nAbs = Math.abs(n);
  const rem100 = nAbs % 100;
  if (rem100 >= 11 && rem100 <= 14) {
    return `${n} записей`;
  }
  const rem10 = nAbs % 10;
  if (rem10 === 1) {
    return `${n} запись`;
  }
  if (rem10 >= 2 && rem10 <= 4) {
    return `${n} записи`;
  }
  return `${n} записей`;
}

export function pluralNaObrashcheniy(m) {
  const mAbs = Math.abs(m);
  const rem100 = mAbs % 100;
  if (rem100 >= 11 && rem100 <= 14) {
    return `на ${m} обращений`;
  }
  const rem10 = mAbs % 10;
  if (rem10 === 1) {
    return `на ${m} обращение`;
  }
  if (rem10 >= 2 && rem10 <= 4) {
    return `на ${m} обращения`;
  }
  return `на ${m} обращений`;
}

/**
 * Исправление грамматики основания карточки Booked Consults:
 * «в OS записано 2 записей на 231 обращений» -> «в OS записано 2 записи на 231 обращение»
 */
export function formatBookedConsultsReason(reason) {
  if (!reason || typeof reason !== 'string') return reason;
  return reason.replace(
    /в OS записано (\d+) записе[йяиь]+ на (\d+) обращени[йяеи]+(.*)/,
    (_, nStr, mStr, rest) => {
      const n = parseInt(nStr, 10);
      const m = parseInt(mStr, 10);
      return `в OS записано ${pluralZapisi(n)} ${pluralNaObrashcheniy(m)}${rest}`;
    }
  );
}
